import {IconButton} from '@mui/material'
import {SxType} from '@baseTypes/sx/sxTypes'
import {FC, ReactNode, SyntheticEvent} from 'react'
import {useThemeContext} from '@view/theme/context/hooks/useThemeContext'

interface IProps {
	onClick?: (e: SyntheticEvent) => void,
	onMouseEnter?: (e: any) => void,
	onMouseOver?: (e: any) => void,
	onMouseOut?: (e: any) => void,
	onMouseLeave?: (e: any) => void,
	size?: 'small' | 'medium' | 'large',
	color?: string,
	hoverColor?: string,
	disabled?: boolean,
	variant?: 'empty',
	tooltip?: string,
	tooltipProps?: any,
	sx?: SxType,
	children?: ReactNode,
	title?: string,
	className?: string,
	sxWrapper?: SxType
}

const IconButtonCustom: FC<IProps> = ({
										  children,
										  onClick,
										  onMouseEnter,
										  onMouseOver,
										  onMouseOut,
										  onMouseLeave,
										  size = 'small',
										  color,
										  hoverColor,
										  disabled,
										  variant,
										  tooltip,
										  sx,
										  title,
										  className,
									  }) => {
	
	const {theme} = useThemeContext()
	
	const iconButtonCustomSx = {
		empty: {
			backgroundColor: 'transparent',
			padding: '0',
			borderRadius: '0',
			width: 'auto',
			height: 'auto',
			transition: 'all .3s',
			'&:hover': {
				cursor: 'pointer',
				backgroundColor: 'transparent',
				opacity: '.7'
			},
		},
		root: {
			backgroundColor: theme === 'dark' ? 'rgba(36,36,36,1)' : color,
			padding: '5px',
			borderRadius: '5px',
			width: '26px',
			height: '26px',
			transition: 'all .3s',
			'&:hover': {
				cursor: 'pointer',
				backgroundColor: theme === 'dark' ? 'rgba(36,36,36,1)' : hoverColor ?? color,
				opacity: '.7'
			},
		}
	}
	
	
	if (variant === 'empty') {
		return (
			<span>
               <IconButton
				   onMouseEnter={onMouseEnter}
				   onMouseOut={onMouseOut}
				   onMouseOver={onMouseOver}
				   onMouseLeave={onMouseLeave}
				   component={'button'}
				   onClick={onClick}
				   size={size}
				   disabled={disabled}
				   sx={{...iconButtonCustomSx.empty, ...sx}}
				   title={title || tooltip}
				   className={className}
			   >
               {children}
           </IconButton>
          </span>
		)
	}
	
	return (
		<span>
            <IconButton
				onMouseEnter={onMouseEnter}
				onMouseOut={onMouseOut}
				onMouseOver={onMouseOver}
				onMouseLeave={onMouseLeave}
				component={'button'}
				onClick={onClick}
				size={size}
				disabled={disabled}
				sx={{...iconButtonCustomSx.root, ...sx}}
				title={title || tooltip}
				className={className}
			>
            {children}
        </IconButton>
       </span>
	)
}

export default IconButtonCustom